import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function MultipleSelectComponent(props) {
    const {value} = props

    const [valueMultipSelect, setValueMultipSelect] = React.useState("");
    
    React.useEffect(() => {
      if(value.length === 0)
        return setValueMultipSelect([])
      for (var i = 0; i < value.length; i++) {
        value[i] = value[i].replace(/\.vn$/, "");
        setValueMultipSelect(value)
      }
    }, [value]);
      
    return (
        <Autocomplete
          multiple
          id="checkboxes-tags-demo"
          options={props.data}
          limitTags={3}
          disableCloseOnSelect
          getOptionLabel={(option) => option ?? ""}
          filterSelectedOptions
          getOptionDisabled={(option) => {
            if (value.some((All) => All === "Tất cả")) {
              return true;
            }
            if (value.some((All) => All !== "Tất cả" )&& option === "Tất cả") {
              return true;
            }
            return false;
          }}
          renderOption={(option, { selected }) => (
            <React.Fragment>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option}
            </React.Fragment>
          )}
          size="small"
          style={{ width: '100%',}}
          onChange={(e, value)=> props.onChange(value)}
          value={valueMultipSelect ? valueMultipSelect : []}
          renderInput={(params) => (
            <TextField 
              {...params}
              InputLabelProps={{
                shrink: true,
                }} 
              margin="dense" 
              label={props.name} 
              variant="outlined" 
            />
          )}
          disabled={props.disabled}
        />)
}
    